import React from 'react'
import classnames from 'classnames'

import styles from './Input.module.scss'

const Input = React.forwardRef(({ className, ...restProps }, ref) => (
  <input
    className={classnames(className, styles.input)}
    ref={ref}
    {...restProps}
  />
))

export default Input
